<!--
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-12-25 17:26:38
 * @FilePath: \frontend\src\layout\components\Navbar.vue
-->
<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="navbar" style="z-index: 9999">
    <el-row style="background: #545c64">
      <el-col :lg="menuSpan" :md="menuSpan - 1" :sm="menuSpan - 2" :xs="menuSpan - 2">
        <CustomMenu />
      </el-col>

      <el-col
        :lg="{ span: 4, offset: menuOffset }"
        :md="{ span: 4, offset: menuOffset }"
        :sm="{ span: 4, offset: menuOffset - 1 }"
        :xs="{ span: 4, offset: menuOffset - 1 }"
        style="height: 50px; display: flex; align-items: center; justify-content: flex-end"
      >
        <el-divider v-if="tenantName !== ''" class="custom-divider" direction="vertical" />
        <el-tooltip effect="dark" :content="tenantName" placement="bottom-end" :offset="35">
          <span class="tenant-text">
            {{ tenantName }}
          </span>
        </el-tooltip>
        <el-divider v-if="tenantName !== ''" class="custom-divider" direction="vertical" />
        <!--
        <div style="height: 100%;display: flex;align-items: center;">
          <el-divider class="custom-divider" direction="vertical" />

          <el-link :underline="false" style="color:aliceblue;text-align:center;" @click="timeClick">
            <span :style="timeStyle" style="display: flex;padding-left:10px;padding-right:10px;margin:20px;">
              {{ time === '' ? '-' : new Date(time).Format('yyyy-MM-dd hh:mm:ss') }}
            </span>
          </el-link>

          <el-divider class="custom-divider" direction="vertical" />
        </div>
        -->
      </el-col>

      <el-col :lg="4" :md="5" :sm="7" :xs="7">
        <div class="right-menu">
          <el-tooltip effect="dark" :content="$t('navbar.contact')" placement="bottom-end">
            <Contact style="padding-right: 10px" class="right-menu-item hover-effect" />
          </el-tooltip>
          <el-tooltip effect="dark" :content="$t('navbar.screenfull')" placement="bottom-end">
            <Screenfull id="screenfull" style="padding-right: 10px" class="right-menu-item hover-effect" />
          </el-tooltip>

          <el-tooltip effect="dark" :content="$t('navbar.lang')" placement="bottom-end">
            <ChangeLang style="padding-right: 10px" class="right-menu-item hover-effect" />
          </el-tooltip>

          <!--
          <el-tooltip
            v-if="mode === 0"
            style="padding-right:30px"
            class="right-menu-item hover-effect"
            effect="dark"
            :content="$t('navbar.notConfirmAlert')"
            placement="bottom-end"
          >
            <not-confirm-alert />
          </el-tooltip>
          -->

          <el-dropdown style="color: aliceblue" class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
              <el-avatar style="font-weight: bold; font-size: large; padding-right: 2px">
                {{ user_name ? user_name[0].toUpperCase() : '' }}
              </el-avatar>
              <el-icon class="el-icon-caret-bottom" style="color: aliceblue; font-size: 10px; padding-top: 5px">
                <CaretBottom />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu class="user-dropdown">
                <!-- 
                <el-dropdown-item @click.native="changePassword">
                  <span style="display:block;">{{ $t('navbar.changePass') }}</span>
                </el-dropdown-item> 
                <el-dropdown-item divided @click.native="logout"> 
                -->
                <el-dropdown-item class="logout" @click="logout">
                  <span style="display: block">{{ $t('navbar.logOut') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>

    <!--
    <el-dialog
      :title="$t('navbar.changePass')"
      :destroy-on-close="true"
      v-model="pwdDialogVisible"
      width="40%"
      :show-close="false"
      @closed="handleCancel"
    >
      <el-form ref="pwd" label-width="150px" :model="pwd" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('navbar.oldPass') + ':'" prop="oldPwd">
              <el-input ref="oldPwd" v-model="pwd.oldPwd" style="width:300px" :type="oldPwdType">
                <i slot="suffix" class="show-pwd" @click="showOldPwd">
                  <svg-icon :icon-class="oldPwdType === 'password' ? 'eye' : 'eye-open'" />
                </i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('navbar.newPass') + ':'" prop="newPwd">
              <el-input ref="newPwd" v-model="pwd.newPwd" style="width:300px" :type="newPwdType">
                <i slot="suffix" class="show-pwd" @click="showNewPwd">
                  <svg-icon :icon-class="newPwdType === 'password' ? 'eye' : 'eye-open'" />
                </i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('navbar.confirmPass') + ':'" prop="confirmPwd">
              <el-input v-show="false" v-model="pwd.newPwd" />
              <el-input ref="confirmPwd" v-model="pwd.confirmPwd" style="width:300px" :type="confirmPwdType">
                <i slot="suffix" class="show-pwd" @click="showConfirmPwd">
                  <svg-icon :icon-class="confirmPwdType === 'password' ? 'eye' : 'eye-open'" />
                </i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="16">
            <div>
              <el-form-item />
            </div>
          </el-col>

          <el-col :span="4">
            <el-button @click="handleCancel">
              {{ $t('navbar.cancel') }}
            </el-button>
          </el-col>

          <el-col :span="4">
            <el-button type="primary" :loading="isLoading" @click="handleConfirm">
              {{ $t('navbar.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { updatePwd } from '@/api/user';
// import { isValidUserPass, isValidConfirmPass } from '@/utils/validate';
// import { successMsg } from '@/utils/message';
import Contact from '@/components/Contact/index.vue';
import Screenfull from '@/components/Screenfull/index.vue';
import ChangeLang from '@/components/ChangeLang/index.vue';
import CustomMenu from '@/layout/components/Menu/index.vue';
import { CaretBottom } from '@element-plus/icons-vue';
// import { getSysTime, getSysCfg } from '@/api/sys';
// import { roleId, sysCfgType } from '@/utils/const';
import { getTenantName } from '@/api/tenant';
import { amplifySignOut } from '@/utils/auth';

export default {
  components: {
    CustomMenu,
    Contact,
    Screenfull,
    ChangeLang,
    CaretBottom,
  },
  data() {
    return {
      menuSpan: 14,
      menuOffset: 2,
      fullscreenLoading: false,
      tenantName: '',
      isOverflowed: false,
      /*
      pwdDialogVisible: false,
      pwd: {},
      newPwdType: 'password',
      oldPwdType: 'password',
      confirmPwdType: 'password',
      isLoading: false,
      timeStyle: {
        height: '80%',
        backgroundColor: 'rgb(84, 92, 100)',
      },
      rules: {
        newPwd: [
          {
            required: true,
            message: this.$t('navbar.newPassRequired'),
            trigger: 'blur',
          },
          {
            validator: isValidUserPass,
            trigger: 'blur',
          },
        ],
        oldPwd: [
          {
            required: true,
            message: this.$t('navbar.oldPassRequired'),
            trigger: 'blur',
          },
        ],
        confirmPwd: [
          {
            required: true,
            message: this.$t('navbar.confirmPassRequired'),
            trigger: 'blur',
          },
          {
            validator: isValidConfirmPass,
            trigger: 'blur',
          },
        ],
      },
      */
    };
  },
  computed: {
    ...mapGetters(['mode', 'sidebar', 'user_name', 'isInit', 'tenantId']),
    /*
    time: {
      get() {
        return this.$store.state.system.time;
      },
      set(value) {
        this.$store.dispatch('system/setTime', value);
        if (!global.timeInterval) {
          if (value !== '') {
            global.timeInterval = setInterval(() => {
              this.time += 1000;
            }, 1000);
          }
        }
      },
    },
    isShowNotification: {
      get() {
        return this.$store.state.system.isShowNotification;
      },
      set(value) {
        this.$store.dispatch('system/setIsShowNotification', value);
      },
    },
    */
  },
  watch: {
    /*
    time: {
      immediate: true,
      handler() {
        if (new Date().getTime() - this.time > 30 * 1000 || this.time - new Date().getTime() > 30 * 1000) {
          this.timeStyle = {
            height: '80%',
            backgroundColor: '#F56C6C',
          };
        } else {
          this.timeStyle = {
            height: '80%',
            backgroundColor: 'rgb(84, 92, 100)',
          };
        }
      },
    },
    */
    /*
    isInit: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.isInit) {
          // this.getSysInfo();

          if (this.mode === 1) {
            this.message({
              message: this.$t('navbar.inSubgUdpMode'),
              type: 'warning',
              showClose: true,
            });
          }
        }
      },
    },
    */
  },
  created() {
    this.getTenantName();
    // this.initIsShowNotification();
    this.initMenuSpan();

    // document.addEventListener('visibilitychange', () => {
    //   if (document.visibilityState === 'visible') {
    //     this.getSysInfo();
    //   }
    // });
  },
  methods: {
    initMenuSpan() {
      // mode = 1 is not implimented
      /*
      if (this.mode === 0) {
        this.menuSpan = 14;
        this.menuOffset = 2;
      } else {
        this.menuSpan = 10;
        this.menuOffset = 7;
      }
      */
      this.menuSpan = 14;
      this.menuOffset = 2;
    },
    /*
    timeClick() {
      if (this.role_id !== roleId.guest) {
        this.$router.push({
          path: '/SystemTime',
        });
      }
    },
    */
    async getTenantName() {
      const tenantName = await getTenantName({ tenant: this.tenantId });
      if (tenantName) {
        this.tenantName = tenantName;
      }
    },
    /*
    initIsShowNotification() {
      getSysCfg({
        cfg_key: sysCfgType.notification,
      }).then(data => {
        if (data.status === 0) {
          if (data.data.length !== 0) {
            this.isShowNotification = JSON.parse(data.data[0].cfg_value).isShowNotification;
          }
        }
      });
    },
    */
    async logout() {
      this.fullscreenLoading = true;
      try {
        await amplifySignOut();
        this.$router.push({ path: '/login' });
        // this.$socket.destroy()
        // destroySocket()
        this.fullscreenLoading = false;
      } catch {
        this.fullscreenLoading = false;
      }
    },
    /*
    showNewPwd() {
      if (this.newPwdType === 'password') {
        this.newPwdType = '';
      } else {
        this.newPwdType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.newPwd.focus();
      });
    },
    */
    /*
    showOldPwd() {
      if (this.oldPwdType === 'password') {
        this.oldPwdType = '';
      } else {
        this.oldPwdType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.oldPwd.focus();
      });
    },
    */
    /*
    showConfirmPwd() {
      if (this.confirmPwdType === 'password') {
        this.confirmPwdType = '';
      } else {
        this.confirmPwdType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.confirmPwd.focus();
      });
    },
    */
    /*
    handleCancel() {
      this.pwdDialogVisible = false;
      this.pwd.oldPwd = '';
      this.pwd.newPwd = '';
      this.pwd.confirmPwd = '';
    },
    */
    /*
    handleConfirm() {
      this.$refs.pwd.validate(valid => {
        if (valid) {
          this.isLoading = true;
          updatePwd({
            user_name: this.user_name,
            newPwd: this.pwd.newPwd,
            oldPwd: this.pwd.oldPwd,
          }).then(data => {
            if (data.status === 0) {
              this.notify({
                title: this.$t('navbar.success'),
                message: successMsg.Change_pass_success,
                type: 'success',
                duration: 2000,
              });
              this.pwdDialogVisible = false;
              this.logout();
            }
            this.isLoading = false;
          });
        }
      });
    },
    */
    /*
    changePassword() {
      this.pwdDialogVisible = true;
    },
    */
    /*
    getSysInfo() {
      getSysTime().then(data => {
        if (data.status === 0) {
          clearInterval(global.timeInterval);
          global.timeInterval = null;

          const date = new Date(data.data.time);

          if (this.isValidDate(date)) {
            this.time = date.getTime();
          } else {
            this.time = '';
          }
        }
      });
    },
    */
    /*
    isValidDate(date) {
      return date instanceof Date && !isNaN(date.getTime());
    },
    */
  },
};
</script>

<style>
.el-form-item__error {
  width: 400px;
}
</style>

<style lang="scss" scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
  position: absolute;
}

.custom-divider {
  background-color: #c0c4cc;
  width: 2px;
  height: 60% !important;
  margin: 0px;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 1000;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .tenant-text {
    color: aliceblue;
    text-align: center;
    margin: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .right-menu {
    float: right;
    height: 100%;
    display: flex;
    // align-items: center;
    // justify-content: center;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      :deep(.el-dropdown) {
        vertical-align: baseline;
        line-height: 50px !important;
      }
    }

    .avatar-container {
      // margin-right: 30px;
      margin-right: 22px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
